import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import SelectionBox from './Components/SelectionBox';
import WidgetTitle from './WidgetTitle';
import CriteriaMiniBox from './Components/CriteriaMiniBox';
import './CriteriaMiniWidget.css';
import Config from './Configs/criteria.json';
import Tooltip from 'react-tooltip-lite';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import './Tooltip.css';

export default class CriteriaMiniWidget extends Component {
    constructor(props) {
        super(props);
    //     this.handleSelectionBoxChange = this.handleSelectionBoxChange.bind(this);
    //     this.handlePopupChange =this.handlePopupChange.bind(this);
    let tmpCountCheck=false;
    if(this.getNumberOfSelectedItem()>9){
        tmpCountCheck=true;
    }
this.state={
    addadvcriteriaBtn:tmpCountCheck
}    
}
    handleSelectionBoxChange = (name, value, ischecked) => {
        this.props.handleSelectionBoxChange(name, value, ischecked, true);
    }
    handlePopupChange = (type) => (e) => {
        this.props.handlePopupChange(type);
    }
    handleSelectAllMarket = () => {
        this.props.handleSelectAllMarket(true);
    }
    handleInvestAmtChange = (e) => {
        let investamtfrom = this.props.criteria.investamt[0];
        let investamtto = this.props.criteria.investamt[1];
        if (e.target.name === "investamtfrom") {
            investamtfrom = parseInt(e.target.value);
            if (investamtfrom === "" || investamtfrom < 0) {
                investamtfrom = -1;
            }
        } else if (e.target.name === "investamtto") {
            investamtto = parseInt(e.target.value);
            if (investamtto === "" || investamtto < 0) {
                investamtto = -1;
            }
        }
        this.props.handleInvestAmtChange([investamtfrom, investamtto], true);
    }
    handleKeyPress = (e) => {
        e = e || window.event;
        let charCode = (typeof e.which == "number") ? e.which : e.keyCode;

        // Allow non-printable keys
        if (!charCode || charCode === 8 /* Backspace */ ) {
            return true;
        }
        
        let typedChar = String.fromCharCode(charCode);
        
        // Allow numeric characters and minus sign (-)
        if (/\d/.test(typedChar) || typedChar === "-" || typedChar === ".") {
            return true;
        }
        
        // In all other cases, suppress the event
        e.preventDefault();
        return false;
    }
    handleCriteriaBoxChange = (key, i) => (criteriavalues, cb) => {
        
        this.props.handleCriteriaBoxChange(key, i, criteriavalues, cb);
        if(this.getNumberOfSelectedItem()<10){
            this.setState({addadvcriteriaBtn:false});
        }else{
            this.setState({addadvcriteriaBtn:true});
        }

    }
    onDragEnd = (result) => {
        const { destination, source } = result;
        if (!destination) {
            return;
        }
        let sortby =this.props.sortby;
        if(sortby.substring(1, 2)==source.index){
            sortby="a"+destination.index
        }else{
            if(this.props.sortby.length==2){
                if(sortby.substring(1, 2)>=destination.index && sortby.substring(1, 2)<source.index){
                    sortby="a"+(parseInt(sortby.substring(1, 2))+1);
                }else if(sortby.substring(1, 2)<=destination.index && sortby.substring(1, 2)>source.index){
                    sortby="a"+(parseInt(sortby.substring(1, 2))-1);
                }
            }
        }
        let aq = this.props.advancedQueue;
        aq.splice(destination.index, 0, aq.splice(source.index, 1)[0]);
        this.props.handleDragEnd(aq,sortby);
    }
    getSelectedSectorCount = () => {
        let count = 0;
        for (let i=0; i<this.props.criteria.sector.length; i++) {
            if (this.props.criteria.sector[i]) {
                count++;
            }
        }
        return count;
    }
    getSelectedScoreCount = () => {
        let count = 0;
        for (let i=0; i<this.props.criteria.score.length; i++) {
            if (!this.props.criteria.score[i].disabled) {
                count++;
            }
        }
        return count;
    }
    generateSelectedAdvancedCriteriaBox = () => {
        let row = [];
        if (this.props.advancedQueue && this.props.advancedQueue.length > 0) {
            for (let i=0; i<this.props.advancedQueue.length; i++) {
                if (this.props.criteria.advanced[this.props.advancedQueue[i].key][this.props.advancedQueue[i].i].selected) {
                    row.push(<Draggable key={this.props.advancedQueue[i].key+"|"+this.props.advancedQueue[i].i} draggableId={this.props.advancedQueue[i].key+"|"+this.props.advancedQueue[i].i} index={i}>{(provided, snapshot) => (<div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    ><CriteriaMiniBox token={this.props.token} fromPreset={this.props.fromPreset} key={Config.criteria.advanced[this.props.advancedQueue[i].key][this.props.advancedQueue[i].i].id} onChange={this.handleCriteriaBoxChange(this.props.advancedQueue[i].key, this.props.advancedQueue[i].i)} data={this.props.criteria.advanced[this.props.advancedQueue[i].key][this.props.advancedQueue[i].i]} config={Config.criteria.advanced[this.props.advancedQueue[i].key][this.props.advancedQueue[i].i]} /></div>)}</Draggable>);
                }
            }
        } else {
            Object.keys(Config.criteria.advanced).forEach((key) => {
                for (let i=0; i<Config.criteria.advanced[key].length; i++) {
                    if (this.props.criteria.advanced[key][i].selected) {
                    row.push(<Draggable key={key+"|"+i} draggableId={key+"|"+i} index={i}>{(provided, snapshot) => (<div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    ><CriteriaMiniBox fromPreset={this.props.fromPreset} key={Config.criteria.advanced[key][i].id} onChange={this.handleCriteriaBoxChange(key, i)} data={this.props.criteria.advanced[key][i]} config={Config.criteria.advanced[key][i]} /></div>)}</Draggable>);
                    }
                }
            });
        }
        return row;
    }
    getNumberOfSelectedItem = () => {
        let type = [];
        Object.keys(Config.criteria.advanced).forEach((key) => {
            type.push(key);
        });
        let count = 0;
        for (let i=0; i<type.length; i++) {
            for (let j=0; j<this.props.criteria.advanced[type[i]].length; j++) {
                if (this.props.criteria.advanced[type[i]][j].selected) {
                    count++;
                }
            }
        }
        return count;
    }
    isSelectAllMarketChecked = () => {
        return this.props.isSelectAllMarketChecked();
    }
    render() {
        return (
            <div className="CriteriaMiniWidget">
                <WidgetTitle content="検索条件" />
                <Collapsible trigger="基本条件" open={true}>
                    <Collapsible classParentString="innerCollapsible" trigger={<div><span>市場 <Tooltip className="info" direction="right-start" content={<div>選択した市場に上場している銘柄を表示します。<br/>東証ETFは、ETNを含みます。<br/>地方市場は、名証、福証、札証を含みます。<br/>その他は、インフラファンド、外国株、優先出資証券、上場前銘柄を含みます。</div>} arrow={false}>?</Tooltip></span><span className="box" /></div>} open={true}>
                        <div className="container">
                        {
                            Config.criteria.market.map((market, idx) => 
                           {    
                                return <SelectionBox key={market.id} type="mini" label={market.name} name="market" value={idx} onChange={this.handleSelectionBoxChange} ischecked={this.props.criteria.market[idx]} count={this.props.data?this.props.data[market.resultid]:0}/>
                            })
                        }
                            <SelectionBox key="selectallmini" type="selectallmini" label="すべて選択する" name="selectallmini" value="" onChange={this.handleSelectAllMarket} ischecked={this.isSelectAllMarketChecked()} />
                        </div>
                    </Collapsible>
                    <Collapsible classParentString="innerCollapsible" trigger={<div><span>規模 <Tooltip className="info" direction="right-start" content={(<div>大型株：時価総額上位100位<br/>中型株：時価総額101位から500位<br/>小型株：時価総額501位以下</div>)} arrow={false}>?</Tooltip></span><span className="box" /></div>} open={true}>
                        <div className="container">
                        {
                            Config.criteria.capsize.map((capsize, idx) => (
                                <SelectionBox key={capsize.id} type="mini" label={capsize.name} name="capsize" value={capsize.id} onChange={this.handleSelectionBoxChange} ischecked={this.props.criteria.capsize[idx]} count={this.props.data?this.props.data[capsize.resultid]:0}/>
                            ))
                        }
                        </div>
                    </Collapsible>
                    <Collapsible classParentString="innerCollapsible" trigger={<div><span>採用指数<Tooltip className="info" direction="right-start" content="選択した指数に採用されている銘柄を表示します。" arrow={false}>?</Tooltip></span><span className="box" /></div>} open={true}>
                        <div className="container">
                        {
                            Config.criteria.index.map((index, idx) => (
                                <SelectionBox key={index.id} type="mini" label={index.name} name="index" value={index.id} onChange={this.handleSelectionBoxChange} ischecked={this.props.criteria.index[idx]} />
                            ))
                        }
                        </div>
                    </Collapsible>
                    <Collapsible classParentString="innerCollapsible" trigger={<div><span>業種 <Tooltip className="info" direction="right-start" content="選択した業種に分類されている銘柄を表示します。" arrow={false}>?</Tooltip></span><span className="box" /></div>} open={true}>
                        <div className="currselection">
                            { this.getSelectedSectorCount()===Config.criteria.sector.length ? "すべての業種選択中" : this.getSelectedSectorCount() + "/" + Config.criteria.sector.length + "業種選択中" }
                        </div>
                        <div className="selectionbox" onClick={this.handlePopupChange("sector")}>
                            業種選択
                        </div>
                    </Collapsible>
                    <Collapsible classParentString="innerCollapsible" trigger={<div><span>NISA<Tooltip className="info" direction="right-start" content="NISA（成長投資枠）で取引できる銘柄を検索できます。" arrow={false}>?</Tooltip></span><span className="box" /></div>} open={true}>
                        <div className="container">
                        {
                            Config.criteria.nisa.map((nisa, idx) => (
                                <SelectionBox key={nisa.id} extrawidth="extrawidth" type="mini" label={nisa.name} name="nisa" value={nisa.id} onChange={this.handleSelectionBoxChange} ischecked={this.props.criteria.nisa[idx]} />
                            ))
                        }
                        </div>
                    </Collapsible>
                    <Collapsible classParentString="innerCollapsible" trigger={<div><span>レバレッジ/インバース<Tooltip className="info" direction="right-start" content="レバレッジ型（ブル型）/インバース型（ベア型）の銘柄を検索できます。" arrow={false}>?</Tooltip></span><span className="box" /></div>} open={true}>
                        <div className="container">
                        {
                            Config.criteria.bullbear.map((bullbear, idx) => (
                                <SelectionBox key={bullbear.id} extrawidth="extrawidth" type="mini" label={bullbear.name} name="bullbear" value={bullbear.id} onChange={this.handleSelectionBoxChange} ischecked={this.props.criteria.bullbear[idx]} />
                            ))
                        }
                        </div>
                    </Collapsible>
                    <Collapsible classParentString="innerCollapsible" trigger={<div><span>企業スコア <Tooltip className="info" direction="right-start" content="企業スコアは、株価や財務、収益予想データ等を使用して、リフィニティブ社が定義した定量分析により算出した数値です。各10段階評価で10が最高の評価を表します。" arrow={false}>?</Tooltip></span><span className="box" /></div>} open={true}>
                        <div className="currselection">
                        { this.getSelectedScoreCount()===Config.criteria.score.length ? "すべてのスコアを選択中" : this.getSelectedScoreCount() + "/" + Config.criteria.score.length + "企業スコア選択中" }
                        </div>
                        <div className="selectionbox" onClick={this.handlePopupChange("companyscore")}>
                            企業スコア選択
                        </div>
                    </Collapsible>
                    <Collapsible classParentString="innerCollapsible" trigger={<div><span>投資金額 <Tooltip className="info" direction="right-start" content="株価(終値)に売買単位株数をかけて算出された値です。" arrow={false}>?</Tooltip></span><span className="box" /></div>} open={true}>
                        <div className="investamt container">
                            <input maxlength='6' type="text" name="investamtfrom" value={(this.props.criteria.investamt[0]===-1||!this.props.criteria.investamt[0])?"":this.props.criteria.investamt[0]} onChange={this.handleInvestAmtChange} onKeyPress={this.handleKeyPress} />
                            <div className="investamttext">万円<br/>以上</div>
                            <input maxlength='6' type="text" name="investamtto" value={(this.props.criteria.investamt[1]===-1||!this.props.criteria.investamt[1])?"":this.props.criteria.investamt[1]} onChange={this.handleInvestAmtChange} onKeyPress={this.handleKeyPress} />
                            <div className="investamttext">万円<br/>以下</div>
                        </div>
                    </Collapsible>
                </Collapsible>
                <Collapsible trigger={<div className="advanced"><div className="text">詳細条件</div><div className="counter" style={{display: this.getNumberOfSelectedItem()>0?"block":"none"}}>{this.getNumberOfSelectedItem()}</div></div>} open={true}>
                    <DragDropContext onDragEnd={this.onDragEnd}>
                        <Droppable droppableId="droppable-1">
                            {(provided, snapshot) => (
                                <div
                                ref={provided.innerRef}>
                                { this.generateSelectedAdvancedCriteriaBox() }
                                {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                    <div className={(this.props.acSelectedCount<=9)?"addadvcriteria":"hiddenaddadvcriteria"} onClick={this.handlePopupChange("advcriteria")}>+ 検索条件を追加</div>
                </Collapsible>
            </div>
        );
    }
}